const cellphoneMask = '(00) 0 0000-0000';
const phoneMask = '(00) 0000-0000';
const cpfMask = '000.000.000-00';
const cnpjMask = '00.000.000-0000.00';
const none = '000000000000';

export { cellphoneMask, phoneMask, cnpjMask, cpfMask, none };
